import "./CheckOutList.css";
import { ReactComponent as ArrowDownIcon } from "../../assets/icons/arrow_down.svg";
import { ReactComponent as CartIcon } from "../../assets/icons/shopping_cart.svg";
import { ReactElement, useContext, useState } from "react";
import { setOrderDetails } from "../../state_management/actions";
import { connect } from "react-redux";
import { stateType } from "../../store";
import { cartItem, extrasCartItem } from "../../state_management/reducers/cart";
import { orderType } from "../../state_management/reducers/order";
import CheckOutButtons from "../../pages/CheckOut/CheckOutButtons";
import { TotalMinAlert } from "../CheckOutExtra/CheckOutExtra";
import { currency } from "../../utilities/misc";
import CheckOutSummary, { CouponForm } from "./CheckOutSummary";
import { split_cart } from "../../utilities/cartUtilities";
import {
  CartTotalContext,
  LocaleContext,
  TotalWithCouponContext
} from "../../AppProvider";
import { DateTimeInfoHeader } from "../CheckOutAddress/CheckOutAddress";
import { getMinsTotal, timeFormat } from "../../utilities/cleanerTime";
import { ServiceDurationContext } from "../../pages/CheckOut/CheckOutProvider";
import moment from "moment";

const mapStateToProps = (state: stateType) => ({
  cart: state.cartReducer.cart,
  extras: state.cartReducer.extras,
  orderDetails: state.orderReducer.details,
  orderSuccess: state.orderReducer.success,
  orderDirect: state.orderReducer.direct
});

const mapDispatchToProps = (dispatch: any) => ({
  setOrderDetails: (data: orderType) => {
    dispatch(setOrderDetails(data));
  }
});

const CheckOutList = ({
  buttonJSX,
  disabled,
  nextFunction,
  loading,
  cart,
  extras,
  orderDetails
}: {
  cart: cartItem[];
  extras: extrasCartItem[];
  buttonJSX?: ReactElement;
  disabled?: boolean;
  nextFunction?: () => void;
  loading?: boolean;
  orderDetails: orderType;
}) => {
  const { t, locale } = useContext(LocaleContext);
  const [cartTotal] = useContext(CartTotalContext);
  const [totalWithCoupon] = useContext(TotalWithCouponContext);
  const [duration] = useContext(ServiceDurationContext);

  const [listOpen, setListOpen] = useState(false);

  const total = (coupTotal: number | null, total: number) => {
    const allowNum = typeof coupTotal === "number";

    if (allowNum) {
      return coupTotal;
    } else {
      return total;
    }
  };

  const Total = total(totalWithCoupon, cartTotal);
  const { cart: cart_items, gift_values: gift } = split_cart(cart);
  const cartCombined = { cart: cart_items, extras, gift_values: gift };

  const time_start = orderDetails.time_start;
  const timeStartString = time_start ? moment(time_start).format("HH:mm") : "";
  const endTime = timeStartString
    ? timeFormat(getMinsTotal(timeStartString) + duration)
    : undefined;
  const dateMoment = moment(time_start);
  const isValidDate = dateMoment.isValid();
  const date = isValidDate ? dateMoment.format("YYYY-MM-DD") : undefined;
  const startTime = isValidDate ? dateMoment.format("HH:mm") : undefined;

  return (
    <>
      <div className="checkOutList_wrapper">
        <div className="checkOutList_wrapper_lg">
          <DateTimeInfoHeader
            date={date}
            endTime={endTime}
            startTime={startTime}
          />
          <CheckOutSummary
            buttonJSX={
              <>
                <TotalMinAlert className="showLg" />
                {buttonJSX ? (
                  buttonJSX
                ) : (
                  <CheckOutButtons
                    nextFunction={nextFunction}
                    isLarge
                    disabled={disabled}
                    loading={loading}
                  />
                )}
              </>
            }
            cartMerged={cartCombined}
            cartTotal={cartTotal}
            cartWithCouponTotal={Total}
            deactivateBars={false}
            coupon={orderDetails.coupon_code}
            orderDetails={orderDetails}
          />
        </div>
        <div className="checkOutList_wrapper_sm">
          <div
            onClick={() => setListOpen(!listOpen)}
            className="checkout_list_collapse_wrapper"
          >
            <div className="flex1 flex">
              <CartIcon className="cartIcon" />
              <div>
                <span className="collapse_title fontBlue">
                  {t("Show order summary")}
                </span>
                <span>
                  <ArrowDownIcon className="arrowIcon" />
                </span>
              </div>
            </div>
            <div className="fontBlue med_text">
              {currency(Total.toFixed(2), locale)}
            </div>
          </div>
          {listOpen && (
            <div className="checkout_collapse_list">
              <CheckOutSummary
                buttonJSX={
                  <>
                    <TotalMinAlert className="showLg" />
                  </>
                }
                cartMerged={cartCombined}
                cartTotal={cartTotal}
                cartWithCouponTotal={Total}
                deactivateBars={false}
                coupon={orderDetails.coupon_code}
                orderDetails={orderDetails}
              />
            </div>
          )}
        </div>
      </div>
      <div className="couponForm_wrapper_sm">
        <CouponForm
          isSmall
          orderDetails={orderDetails}
          {...cartCombined}
          couponCheck={undefined}
          deactivateBars={false}
        />
        <DateTimeInfoHeader
          date={date}
          endTime={endTime}
          startTime={startTime}
        />
      </div>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckOutList);
